import * as React from 'react';
import { useGridSelector } from '@mui/x-data-grid-pro';
import { gridChartsPanelOpenSelector } from "../../../hooks/features/chartsIntegration/gridChartsIntegrationSelectors.mjs";
import { useGridRootProps } from "../../../hooks/utils/useGridRootProps.mjs";
import { useGridApiContext } from "../../../hooks/utils/useGridApiContext.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export function GridColumnMenuChartsItem(props) {
  const {
    onClick
  } = props;
  const rootProps = useGridRootProps();
  const apiRef = useGridApiContext();
  const isChartsPanelOpen = useGridSelector(apiRef, gridChartsPanelOpenSelector);
  const openChartsSettings = event => {
    onClick(event);
    apiRef.current.setChartsPanelOpen(true);
  };
  if (!rootProps.chartsIntegration) {
    return null;
  }
  return /*#__PURE__*/_jsx(rootProps.slots.baseMenuItem, {
    onClick: openChartsSettings,
    iconStart: /*#__PURE__*/_jsx(rootProps.slots.chartsIcon, {
      fontSize: "small"
    }),
    disabled: isChartsPanelOpen,
    children: apiRef.current.getLocaleText('columnMenuManageCharts')
  });
}